export default __webpack_public_path__ + "static/media/Mask_Group_50.f210edae.svg";